import React from 'react';
import Dropzone from 'react-dropzone';

const FileUpload = ({ handleFiles, error, applicationType = null, fileType }) => {
    // return (

    return (
        <div className="theme-view">
            <Dropzone
                onDrop={handleFiles}
                accept={applicationType}
            >
                {({ getRootProps, getInputProps }) => (
                    <div {...getRootProps()} className="initial-dropzone-itp" style={{ border: '2px dashed #e5322d', padding: '60px', textAlign: 'center', cursor: 'pointer' }}>
                        <input {...getInputProps()} />
                        <p>
                            <strong>Choose {fileType} File(s) or drag them here</strong>
                            <br />
                            <small className="text-muted">Click to select or drag and drop your documents</small>
                        </p>
                    </div>
                )}
            </Dropzone>
            {error && <p className="error-message">{error}</p>}
        </div>
    );
}

export default FileUpload;